<template>
  <div class="testimonial" :class="[modifier]" :data-id="data.id" @click="handleCardClick">
    <div class="testimonial__wrapper">
      <div class="testimonial__user" v-if="data.author">
        <div class="testimonial__user-avatar">
          <img :src="data.author.avatar" />
        </div>
        <div class="testimonial__user-details">
          <div class="testimonial__user-name">{{ userName }}</div>
          <div class="testimonial__user-date">{{ timestamp }}</div>
        </div>
      </div>
      <div class="testimonial__content">
        {{ data.content }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import { withUi } from '@/components/ui'
import { timeToDate } from '@/utils/date'

export default {
  components: {},
  mixins: [withUi],
  props: {
    data: Object,
    modifier: String,
  },
  data() {
    return {}
  },
  computed: {
    // TODO - add read more
    userName() {
      const { first_name, last_name } = this.data.author

      return `${last_name} ${first_name}`
    },
    timestamp() {
      return timeToDate(this.data.created_at)
    },
  },
  methods: {
    handleCardClick() {
      if (this.modifier !== 'full') {
        this.openModal({ name: 'feedback-detail', options: this.data })
      }
    },
    ...mapMutations(['openModal']),
  },
}
</script>

<style lang="scss" scoped>
.testimonial {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  &__wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    position: relative;
    z-index: 1;
    background: #ffffff;
    box-shadow: 0px 4px 21px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 30px 45px 40px 30px;
    transition: box-shadow 0.25s $ease;
    will-change: box-shadow;
  }

  &__user {
    display: flex;
    align-items: center;
  }
  &__user-avatar {
    position: relative;
    z-index: 1;
    flex: 0 0 50px;
    width: 50px;
    height: 50px;
    border-radius: 15px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  &__user-details {
    flex: 1 1 auto;
    padding-left: 20px;
  }
  &__user-name {
    font-weight: bold;
    font-size: 14px;
    line-height: 17px;
    color: $text;
  }
  &__user-date {
    margin-top: 3px;
    font-size: 14px;
    line-height: 1.68;
    color: $dark;
  }
  &__content {
    margin-top: 26px;
    font-size: 14px;
    line-height: 1.53;
  }
  &:hover {
    .testimonial__wrapper {
      box-shadow: 0px 6px 32px rgba(0, 0, 0, 0.16);
    }
  }
  &.full {
    cursor: default;
    .testimonial__wrapper {
      box-shadow: none;
      padding: 0;
    }
  }
}
</style>
